import React, { useState } from 'react';
import Select from 'react-select';
import { motion, AnimatePresence } from 'framer-motion';
import makeAnimated from 'react-select/animated';

const MotionMenu = ({ children, innerRef, innerProps, selectProps, className, ...rest }) => {
  return (
    <AnimatePresence>
      <motion.div
        ref={innerRef}
        {...innerProps}
        className={className}
        initial={{ opacity: 0, y: -8 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -8 }}
        transition={{ duration: 0.4 }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

const animatedComponents = makeAnimated();

const SelectResponsible = ({
  id,
  name,
  label,
  value = [],
  onChange,
  required = false,
  placeholder = 'Selecionar responsável',
  options = [],
  className = ''
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const formattedOptions = options.map(option => ({
    ...option,
    label: option.label,
    value: option.value,
    avatar: option.avatar || 'https://images.pexels.com/photos/8728382/pexels-photo-8728382.jpeg?auto=compress&cs=tinysrgb&w=40&h=40&dpr=2',
  }));

  const formatOptionLabel = ({ label, avatar }) => (
    <div className="flex items-center gap-2">
      <img src={avatar} alt={label} className="w-5 h-5 rounded-full" />
      <span className="text-sm">{label}</span>
    </div>
  );

  const selectedValues = value;

  return (
    <div className={`relative w-full mb-5 ${className}`}>
      {label && (
        <label
          htmlFor={id}
          className={`
            absolute left-4 bg-white px-1 transition-all pointer-events-none z-50
            ${
              selectedValues.length || isFocused
                ? 'top-[-0.5rem] text-sm text-purple-700'
                : 'top-3.5 text-base text-gray-500'
            }
          `}
        >
          {required && '*\u00A0'}
          {label}
        </label>
      )}

      <Select
        inputId={id}
        menuPortalTarget={document.body}
        name={name}
        isMulti
        closeMenuOnSelect={false}
        components={{ Menu: MotionMenu, ...animatedComponents }}
        options={formattedOptions}
        value={selectedValues}
        onChange={(selected) => onChange(selected)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        placeholder=" "
        formatOptionLabel={formatOptionLabel}
        className='z-40'
        styles={{
          control: (base, state) => ({
            ...base,
            padding: '.45rem 4px 0rem 0rem',
            fontSize: '1rem',
            minHeight: '2.625rem',
            borderRadius: '1rem 1rem 1rem 0rem',
            borderColor: state.isFocused ? '#6b21a8' : '#d1d5db',
            boxShadow: state.isFocused ? '0 0 0 1px rgba(168, 85, 247, 0.25)' : 'none',
            '&:hover': {
              borderColor: state.isFocused ? '#6b21a8' : '#d1d5db',
            },
          }),
          menu: (base) => ({
            ...base,
            borderRadius: '0.75rem',
            overflow: 'hidden',
            boxShadow: '0 8px 20px rgba(0,0,0,0.08)',
          }),
          menuPortal: (base) => ({
            ...base,
            zIndex: 30000,
            backgroundColor: 'white',
          }),
          option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused ? '#d6c8dc' : 'transparent',
            color: '#3f1057',
            cursor: 'pointer',
            padding: '0.5rem 0.75rem',
          }),
          multiValue: (base) => ({
            ...base,
            backgroundColor: '#d6c8dc',
            borderRadius: '6px',
            padding: '1px 6px',
          }),
          multiValueLabel: (base) => ({
            ...base,
            color: '#3f1057',
          }),
          multiValueRemove: (base) => ({
            ...base,
            color: '#3f1057',
            ':hover': {
              color: '#3f1057',
              backgroundColor: '#c1b3c5',
            },
          }),
          placeholder: (base) => ({
            ...base,
            fontWeight: '300',
            fontSize: '0.95rem',
            color: 'transparent',
          }),
        }}
      />
    </div>
  );
};

export default SelectResponsible;
